import React, { JSX } from 'react';
import { Button, Row } from 'reactstrap';

import { ApiTravelDateCandidate } from '@ibe/api';

import useTranslation from '../../../Hooks/useTranslation';
import { Price } from '../../../Components/UI/Price/Price';
import DateDisplay from '../../../Components/UI/DateDisplay/DateDisplay';
import fallback from '../../../../_Translations/generated/package-option-panel.en.t.json';
import Keys from '../../../../_Translations/generated/package-option-panel.en.t.json.keys';
import { Nbsp } from '../../../Components/UI/Nbsp';

interface Props {
  travelDate: ApiTravelDateCandidate;
  isSelected?: boolean;
  onSelectDate: (id: string) => void;
  showTotalPriceOnly?: boolean;
  isOverviewElement?: boolean;
}

export default function PriceOptionPanel(props: Props): JSX.Element {
  const { t } = useTranslation('package-option-panel', fallback, Keys);
  const { travelDate, showTotalPriceOnly, isSelected, onSelectDate, isOverviewElement } = props;

  const { price } = travelDate;

  return (
    <Row
      className={`iso__price-option-panel p-2 font-weight-bold flex-column flex-sm-row justify-content-between align-items-center d-flex rounded ${
        isSelected ? 'iso__price-option-panel--selected border-primary' : 'border-secondary'
      }${isOverviewElement ? ' iso__price-option-panel--overview' : ''}`}
    >
      <div className="iso__price-option-panel__section d-flex align-self-start align-self-sm-center align-items-center mr-2">
        <DateDisplay date={travelDate.startDate} /> - <DateDisplay date={travelDate.endDate} />
      </div>
      <div className="iso__price-option-panel__section d-flex justify-content-start justify-content-sm-end mt-1 mt-sm-0">
        <div className="iso__price-option-panel__price-section d-flex flex-column flex-sm-row justify-content-end">
          {price && (
            <div className="mr-0 mr-sm-3 mr-md-5 flex-grow-1 d-flex flex-column justify-content-start justify-content-sm-end align-items-start align-items-sm-end">
              <div className="d-flex justify-content-between justify-content-sm-end w-100 flex-wrap">
                <span className="mr-1">
                  {!isOverviewElement || showTotalPriceOnly
                    ? t(Keys.totalPriceFrom)
                    : t(Keys.perAdult)}
                </span>
                <Nbsp />
                <span>
                  <span className="text-primary font-weight-bold">
                    <Price displayInline align="left" price={price} />
                  </span>
                  {!showTotalPriceOnly && t(Keys.perAdult)}
                </span>
              </div>
              <div className="small text-muted mb-1 text-left text-sm-right">
                {t(Keys.priceInfo)}
              </div>
            </div>
          )}
          <div className="d-flex flex-grow-1 mt-2 mt-sm-0 align-items-center">
            <Button
              color={isSelected || isOverviewElement ? 'primary' : 'secondary'}
              className="iso__price-option-panel__button w-100 text-nowrap"
              onClick={(): void => onSelectDate(travelDate.id)}
            >
              {isSelected ? t(Keys.selected) : ''}
              {!isSelected && !isOverviewElement ? t(Keys.select_date) : ''}
              {isOverviewElement ? t(Keys.continue) : ''}
            </Button>
          </div>
        </div>
      </div>
    </Row>
  );
}
